export const RedirectConfig = {
  linkedIn: 'https://www.linkedin.com/company/healisticgroup',
  instagram: 'https://www.instagram.com/healisticuk',
  facebook: 'https://www.facebook.com/HealisticUK',
  apiDocumentation: 'https://api-docs.healistic.net',
  github: 'https://github.com/healistic',
  prescriberWebapp: 'https://prescriber.healistic.net',
  prescriberWebappSignup: 'https://prescriber.healistic.net/signup',
  pharmacyWebapp: 'https://pharmacy.healistic.net',
  customerWebapp: 'https://order.healistic.net',
};
